import React from 'react';
import { LayoutDashboard, MessageSquare, BarChart3, Settings, TrendingUp, Eye, Heart, MousePointer } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
export function PerformancePage() {
  const navItems = [{
    label: 'My Listings',
    icon: LayoutDashboard,
    path: '/dashboard/seller'
  }, {
    label: 'Inquiries',
    icon: MessageSquare,
    path: '/seller/inquiries',
    badge: '5 New'
  }, {
    label: 'Performance',
    icon: BarChart3,
    path: '/seller/performance'
  }, {
    label: 'Settings',
    icon: Settings,
    path: '/seller/settings'
  }];
  return <DashboardLayout title="Seller Dashboard" navItems={navItems} userInitials="RK" data-id="element-5586">
      <h1 className="text-2xl font-bold mb-8" data-id="element-5587">Listing Performance</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-5588">
        <div className="bg-white border border-gray-300 p-6" data-id="element-5589">
          <div className="flex items-center gap-3 mb-2" data-id="element-5590">
            <div className="p-2 bg-blue-50 rounded" data-id="element-5591">
              <Eye className="w-5 h-5 text-blue-600" data-id="element-5592" />
            </div>
            <h3 className="text-xs font-mono text-gray-500 uppercase" data-id="element-5593">
              Total Views
            </h3>
          </div>
          <p className="text-3xl font-bold" data-id="element-5594">1,248</p>
          <p className="text-xs text-green-600 mt-1 font-mono" data-id="element-5595">
            +12% this week
          </p>
        </div>
        <div className="bg-white border border-gray-300 p-6" data-id="element-5596">
          <div className="flex items-center gap-3 mb-2" data-id="element-5597">
            <div className="p-2 bg-red-50 rounded" data-id="element-5598">
              <Heart className="w-5 h-5 text-red-600" data-id="element-5599" />
            </div>
            <h3 className="text-xs font-mono text-gray-500 uppercase" data-id="element-5600">
              Shortlisted
            </h3>
          </div>
          <p className="text-3xl font-bold" data-id="element-5601">42</p>
          <p className="text-xs text-green-600 mt-1 font-mono" data-id="element-5602">+5% this week</p>
        </div>
        <div className="bg-white border border-gray-300 p-6" data-id="element-5603">
          <div className="flex items-center gap-3 mb-2" data-id="element-5604">
            <div className="p-2 bg-purple-50 rounded" data-id="element-5605">
              <MousePointer className="w-5 h-5 text-purple-600" data-id="element-5606" />
            </div>
            <h3 className="text-xs font-mono text-gray-500 uppercase" data-id="element-5607">CTR</h3>
          </div>
          <p className="text-3xl font-bold" data-id="element-5608">3.8%</p>
          <p className="text-xs text-gray-500 mt-1 font-mono" data-id="element-5609">
            Avg market: 2.1%
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-5610">
        <div className="bg-white border border-gray-300 p-6" data-id="element-5611">
          <h3 className="font-bold text-lg mb-6" data-id="element-5612">Views Over Time</h3>
          <div className="h-64 border-2 border-dashed border-gray-200 bg-gray-50 flex items-center justify-center" data-id="element-5613">
            <div className="text-center text-gray-400" data-id="element-5614">
              <TrendingUp className="w-8 h-8 mx-auto mb-2" data-id="element-5615" />
              <span className="font-mono text-sm" data-id="element-5616">
                [Line Chart Placeholder]
              </span>
            </div>
          </div>
        </div>

        <div className="bg-white border border-gray-300 p-6" data-id="element-5617">
          <h3 className="font-bold text-lg mb-6" data-id="element-5618">Top Performing Listings</h3>
          <div className="space-y-4" data-id="element-5619">
            {[{
            name: 'Premium Corner Plot',
            views: 842,
            inquiries: 12,
            score: 95
          }, {
            name: 'Wakad Land Parcel',
            views: 406,
            inquiries: 5,
            score: 72
          }].map((item, i) => <div key={i} className="border border-gray-200 p-4" data-id="element-5620">
                <div className="flex justify-between mb-2" data-id="element-5621">
                  <span className="font-bold text-sm" data-id="element-5622">{item.name}</span>
                  <span className="font-mono text-xs font-bold text-green-600" data-id="element-5623">
                    Score: {item.score}
                  </span>
                </div>
                <div className="flex gap-4 text-xs text-gray-500 font-mono" data-id="element-5624">
                  <span data-id="element-5625">{item.views} Views</span>
                  <span data-id="element-5626">{item.inquiries} Inquiries</span>
                </div>
                <div className="mt-3 h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-5627">
                  <div className="h-full bg-[#1f2933]" style={{
                width: `${item.score}%`
              }} data-id="element-5628"></div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </DashboardLayout>;
}